"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _validate = require("@/utils/validate");
var _default2 = {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    iconColor: {
      type: Object,
      default: function _default() {
        return {
          color: '#fcfcfc'
        };
      } //新增svg自定义颜色
    },

    className: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 10
    }
  },
  computed: {
    isExternal: function isExternal() {
      return (0, _validate.isExternal)(this.iconClass);
    },
    iconName: function iconName() {
      return "#icon-".concat(this.iconClass);
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
    styleExternalIcon: function styleExternalIcon() {
      return {
        mask: "url(".concat(this.iconClass, ") no-repeat 50% 50%"),
        '-webkit-mask': "url(".concat(this.iconClass, ") no-repeat 50% 50%")
      };
    }
  }
};
exports.default = _default2;